"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartBubble = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ChartBubble = function ChartBubble(_a) {
  var id = _a.id;
  var clipPathId = id ? "ChartBubble__clip0__".concat(id) : 'ChartBubble__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.333 0a7.333 7.333 0 110 14.667A7.333 7.333 0 017.333 0zm12 10.667a4.667 4.667 0 100 9.333 4.667 4.667 0 000-9.333zm-4.666 10.666a2.667 2.667 0 11-5.334 0 2.667 2.667 0 015.334 0z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M0 0H24V24H0z"
  }))));
};

exports.ChartBubble = ChartBubble;